import {Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild} from '@angular/core';
import { Schedule } from '../../../../../model/schedule';
import { NgForOf, NgIf } from '@angular/common';
import {Services} from '../../../../../model/services';
import {ButtonComponent} from '../../../../elements/button/button.component';

@Component({
  selector: 'app-schedule-section',
  imports: [
    NgForOf,
    NgIf,
    ButtonComponent
  ],
  templateUrl: './schedule-section.component.html',
  styleUrls: ['./schedule-section.component.scss']
})
export class ScheduleSectionComponent implements OnInit {
  @ViewChild('movableElement') movableElement!: ElementRef;
  @Output() emitClick: EventEmitter<any> = new EventEmitter();


  scrollLeft: number = 0;

  scroll(event: any) {
    this.scrollLeft = this.movableElement.nativeElement.scrollLeft;
  }

  getActive(start: number, end: number) {
    return this.scrollLeft >= start && this.scrollLeft <= end;
  }

  dates: Schedule[] = [
    {
      title: 'Общее количество тренировок',
      text: '12 льда по 75 минут и 12 ОФП по 60 минут',
      posTop: true,
      start: 0,
      end: 600,
    },
    {
      title: 'Время тренировок',
      text: 'Утро с 9:00 до 12:00\n' +
        'День с 12:00 до 15:00\n' +
        'Вечер с 15:00 до 18:00',
      posTop: false,
      start: 600,
      end: 1100,
    },
    {
      title: 'количество участников',
      text: 'на льду не более 20 игроков и 3 специалистов, которые постоянно подсказывают и помогают в выполнении упражнений',
      posTop: true,
      start: 1100,
      end: 1300,
    },
    {
      title: 'Стоимость',
      text: 'Общая стоимость - 110.000 рублей\n' +
        'Предоплата 30% - 33.000 рублей, не  позднее 26 мая\n' +
        'Оплата 70% - 77.000 рублей, не позднее 3 июня',
      posTop: false,
      start: 1300,
      end: 3000,
    },
  ];

  activeIndex = 0;

  setClass(posTop: boolean) {
    return posTop ? 'schedule-content-info-pos-top' : 'schedule-content-info-pos-bot';
  }

  ngOnInit() {
  }

  protected readonly Services = Services;
}
